import React from 'react'
import { Button, Typography } from '@telavita-core/react-design-kit'
import { format } from 'date-fns'

import { ReactComponent as SuccessIcon } from 'static/svg/green-check.svg'
import { ReactComponent as CheckmarkIcon } from 'static/svg/icon-checkmark.svg'

import * as S from './styles'

interface SuccessContentProps {
  handleClose: () => void
  patientFullName: string
  rescheduleSuccessData: {
    oldDate: Date
    newDate: Date
  }[]
}

function formatDate(date: Date) {
  const day = format(date, 'dd/MM')
  const time = format(date, 'HH:mm')

  return `${day} às ${time}`
}

export const SuccessContent: React.FC<SuccessContentProps> = ({
  handleClose,
  patientFullName,
  rescheduleSuccessData
}) => {
  return (
    <S.Container>
      <SuccessIcon />
      <Typography variant='header4'>
        Reserva(s) remarcada(s)
      </Typography>

      <Typography variant='content2'>
        Paciente <strong>{patientFullName}</strong>
      </Typography>

      <S.InfoContainer>
        {rescheduleSuccessData.map(({ oldDate, newDate }) => {
          return (
            <S.NewReservationInfoWrapper key={`${oldDate}-${newDate}`}>
              <CheckmarkIcon color='#49C327'/>
              <Typography variant='content3'>
                Remarcou de <strong>{formatDate(oldDate)}</strong> para <strong>{formatDate(newDate)}</strong>
              </Typography>
            </S.NewReservationInfoWrapper>
          )
        })}
      </S.InfoContainer>

      <Button variant='contained' onClick={handleClose}>
        Fechar
      </Button>
    </S.Container>
  )
}